import { BaseResource } from 'utils/ApiUtils';

export default class CommunicationEvent extends BaseResource {
  static columns = [
    {
      title: "Inspection #",
      field: "InspectionNumber_Inspection"
    },
    { title: "Inspector", field: "Name_SystemUser" },
    {
      title: "Occurrence Date",
      field: "occurrenceDate",
      type: "date",
      defaultSort: "desc"
    },
    {
      title: "Event Type",
      field: "Description_EventType"
    },
    {
      title: "Description",
      field: "description"
    }
  ];

  static attributes = CommunicationEvent.columns.map((r) => r.field);

  static expand = [
    {
      EventType: {
        select: ["Description"]
      }
    },
    {
      "Ihwi": {
        expand: [
          {
            "Inspection": {
              select: ["InspectionNumber"]
            }
          },
          {
            "Inspection": {
              expand:
              {
                "Rassignment": {
                  expand:
                  {
                    "SystemUser": { "select": ["Name"] }
                  }
                }
              }
            }
          }
        ]
      }
    }
  ];

  constructor(args) {
    super(args, CommunicationEvent.attributes);
  }
}
